import React, { useState, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { getAllData, getAllFilterData } from "../../../Utility/API";
import {
  Box,
  Tabs,
  Tab,
  Button,
  TextField,
  MenuItem,
  IconButton,
  TablePagination,
  Dialog,
  Typography,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import moment from "moment-timezone";
import { useTheme } from "@mui/material/styles";

import PageHeader from "../../../components/PageHeader";
import SectionCard from "../../../components/SectionCard";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { tokens } from "../../../theme";
import { mono, pill, statusKind, th, td, unsettledRowBg, filterFieldSx, tabsSx } from "./uiKit";
import RedemDetails from "./redemDetails";
import CashWithDrawal from "./cashWithDrawal";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </Box>
  );
}

const StatusTypeList = [
  { id: 1, name: "Pending" },
  { id: 2, name: "Processed" },
  { id: 3, name: "Canceled" },
];

const fmtDate = (d) => (d && moment.utc(d).isValid() ? moment.utc(d).format("YYYY-MM-DD") : "");

const toCurrency = (value, fallback = "0.00") => {
  if (value === null || value === undefined || value === "") return fallback;

  const numericValue = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(numericValue) ? numericValue.toFixed(2) : fallback;
};

const RedemptionClaims = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = React.useState(1);
  const [totalcount, setTotalCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [userId, setUserId] = useState("");
  const [statusType, setStatusType] = useState("");
  const [email, setEmail] = useState("");

  const [detailsModal, setDetailModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});

  const [value, setValue] = React.useState("one");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    redemptionClaimList(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
  };

  let filterData = {
    userName: "",
    email: email,
    fromDate: "",
    toDate: "",
    sort: "",
    userId: userId,
    status: statusType,
  };

  useEffect(() => {
    redemptionClaimList(1);
  }, []);

  useEffect(() => {
    redemptionClaimList(page);
  }, [rowsPerPage]);

  const redemptionClaimList = async (page) => {
    let url = `${endPoints.api.GET_REDEMPTIONCLAIM}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, filterData)
      .then((response) => {
        setIsLoading(false);
        if (response?.status === "success") {
          let data = response.data;
          setRows(response.data);
          setTotalCount(data[0]?.totalCount);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      redemptionClaimList(page);
    }
  };

  const downloadCsv = (statusId, filename) => {
    setIsLoading(true);
    fetch(`${endPoints.apiBaseUrl + `giftstransaction/download/${statusId}/csv`}`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
      });
    });
  };

  const csvBtnSx = { textTransform: "none", fontSize: 12, color: tokens.textDim, borderColor: tokens.border, "&:hover": { borderColor: tokens.border2 } };

  return (
    <Box>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <PageHeader
        title="Redemption Claims"
        crumb="Finance / Redemption Claims"
        subtitle="Gift card & cash redemptions · review before payout"
      />

      <SectionCard sx={{ p: 0 }}>
        <Tabs value={value} onChange={handleChange} sx={tabsSx}>
          <Tab
            value="one"
            label={
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                Gift Card {value === "one" && totalcount > 0 && pill(totalcount, "warn")}
              </Box>
            }
          />
          <Tab value="Four" label="Cash" />
        </Tabs>

        {value === "one" && (
          <Box sx={{ p: 2 }}>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", mb: 2 }}>
              <TextField
                select
                size="small"
                label="Status"
                value={statusType}
                onChange={(e) => setStatusType(e.target.value)}
                sx={filterFieldSx}
              >
                <MenuItem value="">All statuses</MenuItem>
                {StatusTypeList.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                size="small"
                label="Customer ID"
                placeholder="Enter Customer ID"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                onKeyDown={handleKeyDown}
                sx={filterFieldSx}
              />
              <TextField
                size="small"
                label="Email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
                sx={filterFieldSx}
              />
              <Button variant="contained" size="small" onClick={() => redemptionClaimList(1)} sx={{ textTransform: "none" }}>
                Search
              </Button>

              <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
                <Button size="small" variant="outlined" startIcon={<FileDownloadOutlinedIcon />} sx={csvBtnSx} onClick={() => downloadCsv(1, "PendingResult.csv")}>
                  Pending
                </Button>
                <Button size="small" variant="outlined" startIcon={<FileDownloadOutlinedIcon />} sx={csvBtnSx} onClick={() => downloadCsv(2, "ProcessedResult.csv")}>
                  Processed
                </Button>
                <Button size="small" variant="outlined" startIcon={<FileDownloadOutlinedIcon />} sx={csvBtnSx} onClick={() => downloadCsv(3, "CanceledResult.csv")}>
                  Canceled
                </Button>
              </Box>
            </Box>

            <Box sx={{ overflowX: "auto" }}>
              <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={th}>Player</th>
                    <th style={th}>VIP</th>
                    <th style={th}>Deposit</th>
                    <th style={th}>Settled</th>
                    <th style={th}>Redeem</th>
                    <th style={th}>Withdrawal</th>
                    <th style={th}>Account</th>
                    <th style={th}>Requested</th>
                    <th style={th}>Processed</th>
                    <th style={th}>Pending Redeem</th>
                    <th style={th}>Pending #</th>
                    <th style={th}></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.length === 0 && !isLoading && (
                    <tr>
                      <td colSpan={12} style={{ ...td, textAlign: "center", color: tokens.textDim }}>
                        No redemption claims found
                      </td>
                    </tr>
                  )}
                  {rows.map((row) => {
                    const unsettled = Number(row.totalDeposit ?? 0) !== Number(row.totalSetlledDeposit ?? 0);
                    return (
                      <tr key={row.id} style={{ background: unsettled ? unsettledRowBg : "transparent" }}>
                        <td style={td}>
                          <div style={{ fontWeight: 600 }}>{row.name}</div>
                          <div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>
                            #{row.user_id} · {row.email}
                          </div>
                        </td>
                        <td style={td}>{row.vipLavel ? pill(row.vipLavel, "neutral") : ""}</td>
                        <td style={{ ...td, fontFamily: mono }}>
                          ${toCurrency(row?.totalDeposit)} {unsettled && pill("unsettled", "bad")}
                        </td>
                        <td style={{ ...td, fontFamily: mono }}>${toCurrency(row.totalSetlledDeposit)}</td>
                        <td style={{ ...td, fontFamily: mono }}>${toCurrency(row?.totalRedeem)}</td>
                        <td style={{ ...td, fontFamily: mono }}>${toCurrency(row?.totalWidhdrawl)}</td>
                        <td style={td}>{row.accountStatus ? pill(row.accountStatus, statusKind(row.accountStatus)) : ""}</td>
                        <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>{fmtDate(row.created_on)}</td>
                        <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>{fmtDate(row.processed_date)}</td>
                        <td style={{ ...td, fontFamily: mono, fontWeight: 700 }}>
                          {row?.totalPendingRedeem ? `$${row.totalPendingRedeem}` : ""}
                        </td>
                        <td style={{ ...td, fontFamily: mono }}>{row.pendingCount}</td>
                        <td style={td}>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                            onClick={() => {
                              setDetailModal(true);
                              setSelectedRecord(row);
                            }}
                          >
                            More Redeem
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Box>
            </Box>

            <TablePagination
              component="div"
              className="hide-rows-per-page-options"
              rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 500]}
              count={rowsPerPage === -1 ? rows.length : totalcount || 0}
              rowsPerPage={rowsPerPage}
              page={page - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              sx={{ borderTop: `1px solid ${tokens.border}`, mt: 1 }}
            />
          </Box>
        )}

        {value === "Four" && (
          <Box sx={{ p: 2 }}>
            <CashWithDrawal />
          </Box>
        )}
      </SectionCard>

      <Dialog
        fullScreen
        open={detailsModal}
        onClose={() => setDetailModal(false)}
        PaperProps={{ sx: { background: tokens.bg } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 1.5,
            borderBottom: `1px solid ${tokens.border}`,
            position: "sticky",
            top: 0,
            zIndex: 2,
            background: tokens.bg,
          }}
        >
          <Typography variant="h6">Redemption Claims Details</Typography>
          <IconButton onClick={() => setDetailModal(false)} aria-label="close">
            <CloseRoundedIcon />
          </IconButton>
        </Box>
        <Box sx={{ p: 3 }}>
          <RedemDetails selectedRecord={selectedRecord} />
        </Box>
      </Dialog>
    </Box>
  );
};

export default RedemptionClaims;
